/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RentType } from './rentType.model';
import { ValorizationType } from './valorizationType.model';
import { ContractParamTemplateRentUnknown } from './contractParamTemplateRentUnknown.model';
import { ContractParamTemplateRentDrupoz } from './contractParamTemplateRentDrupoz.model';


export interface ContractParamTemplate { 
    active?: boolean;
    autoProlongationMonths?: number;
    autoProlongationMonthsUnit?: string;
    contractParamTemplateRentDrupozCollection?: Array<ContractParamTemplateRentDrupoz>;
    contractParamTemplateRentUnknownCollection?: Array<ContractParamTemplateRentUnknown>;
    defaultDocumentTemplateId: number;
    deletable?: boolean;
    durationMonths?: number;
    durationMonthsUnit?: string;
    firstNoticeAfterMonths?: number;
    firstNoticeAfterMonthsUnit?: string;
    furtherRentPossible?: boolean;
    id?: number;
    inflationLimit?: number | null;
    isIndefinite: boolean;
    lastNoticeBeforeMonths?: number;
    lastNoticeBeforeMonthsUnit?: string;
    name: string;
    noticePeriodMonths?: number;
    noticePeriodMonthsUnit?: string;
    payTaxOwner?: boolean;
    payoutDate?: string;
    priceDealPercentageValorization?: number | null;
    rentType?: RentType;
    reqNewAppendixAfterReprice: boolean;
    subcontract?: boolean;
    tenantHasPreemption?: boolean;
    toEconomicYear?: boolean;
    useRentDrupoz?: boolean;
    valorizationType: ValorizationType;
    valorizeOrInflateToDate?: string | null;
}
export namespace ContractParamTemplate {
}


